/**
 * @generated SignedSource<<c3dba36ad1732208d0bb4e5b73a89508>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type finishOneDeliveryOnboardingQuery$variables = Record<PropertyKey, never>;
export type finishOneDeliveryOnboardingQuery$data = {
  readonly onedeliveryProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"ShippingAddressFragment">;
  } | null | undefined;
};
export type finishOneDeliveryOnboardingQuery = {
  response: finishOneDeliveryOnboardingQuery$data;
  variables: finishOneDeliveryOnboardingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "finishOneDeliveryOnboardingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OnedeliveryProfile",
        "kind": "LinkedField",
        "name": "onedeliveryProfile",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShippingAddressFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "finishOneDeliveryOnboardingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OnedeliveryProfile",
        "kind": "LinkedField",
        "name": "onedeliveryProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "baceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "preferredHub",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HubMeta",
                "kind": "LinkedField",
                "name": "meta",
                "plural": false,
                "selections": [
                  (v0/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Warehouse",
            "kind": "LinkedField",
            "name": "warehouse",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "street",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "17f14dab73f7978b844b5fee92dc43ba",
    "id": null,
    "metadata": {},
    "name": "finishOneDeliveryOnboardingQuery",
    "operationKind": "query",
    "text": "query finishOneDeliveryOnboardingQuery {\n  onedeliveryProfile {\n    ...ShippingAddressFragment\n  }\n}\n\nfragment ShippingAddressFragment on OnedeliveryProfile {\n  baceId\n  preferredHub {\n    meta {\n      name\n    }\n  }\n  warehouse {\n    name\n    street\n    postalCode\n    city\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa22fa3eb78692231c8b575b9188af7e";

export default node;
